/**
 * Estimate snapshot
 *
 * Serializes the wizard into the exact subset stored with an estimate and
 * consumed by the shared-estimate loader (see GuestEstimateModal's submit and
 * SharedEstimate's load). Used for both the first authenticated save and the
 * background auto-save so the saved record round-trips identically.
 */

import type { WizardState, Currency } from '../types';

export type WizardSnapshot = Pick<
  WizardState,
  | 'calculationMode'
  | 'projectInfo'
  | 'wallsConfig'
  | 'ceilingConfig'
  | 'dimensionsConfig'
  | 'applicationConfig'
  | 'individualWalls'
  | 'completedSteps'
  | 'currentStep'
> & { currency: Currency };

export function buildWizardSnapshot(s: WizardSnapshot): WizardSnapshot {
  return {
    calculationMode: s.calculationMode,
    projectInfo: s.projectInfo,
    wallsConfig: s.wallsConfig,
    ceilingConfig: s.ceilingConfig,
    dimensionsConfig: s.dimensionsConfig,
    applicationConfig: s.applicationConfig,
    individualWalls: s.individualWalls,
    currency: s.currency,
    completedSteps: s.completedSteps,
    currentStep: s.currentStep,
  };
}
